import { Chip } from '@mui/material';
import { STATUS_CONFIG, APPROVAL_CONFIG } from '../../utils/constants';

export const StatusChip = ({ status }) => {
  const cfg = STATUS_CONFIG[status] || { label: status, color: '#64748b', bg: '#f1f5f9' };
  return (
    <Chip label={cfg.label} size="small"
      sx={{ color: cfg.color, bgcolor: cfg.bg, fontWeight: 600, fontSize: '0.72rem', border: `1px solid ${cfg.color}22` }} />
  );
};

export const ApprovalChip = ({ status }) => {
  const cfg = APPROVAL_CONFIG[status] || { color: '#64748b', bg: '#f1f5f9' };
  return (
    <Chip label={status} size="small"
      sx={{ color: cfg.color, bgcolor: cfg.bg, fontWeight: 600, fontSize: '0.72rem', border: `1px solid ${cfg.color}22` }} />
  );
};
